// Monta a lista só leitura de agentes de uma conexão (AgentesDaConexao):
// - vínculo exato (Prompts.whatsappId = conexão) com as filas dele;
// - vínculo legado (sem conexão) que cobre alguma fila da conexão — ele
//   responde em qualquer conexão até ser editado;
// - o agente "antes da distribuição" (Whatsapps.promptId) da conexão.

const temValor = (v) => v !== null && v !== undefined && v !== "";
const mesmoId = (a, b) => temValor(a) && temValor(b) && Number(a) === Number(b);
const ids = (lista) => (Array.isArray(lista) ? lista : []).map(Number);

export const agentesDaConexao = ({
  prompts,
  filas,
  whatsappId,
  queueIdsDaConexao,
  promptAntesDaFila,
}) => {
  if (!temValor(whatsappId)) return [];
  const filaPorId = new Map((filas || []).map((q) => [Number(q.id), q]));
  const daConexao = new Set(ids(queueIdsDaConexao));

  return (prompts || [])
    .map((p) => {
      const exato = mesmoId(p.whatsappId, whatsappId);
      const legado = !temValor(p.whatsappId);
      const antesDaFila = mesmoId(promptAntesDaFila, p.id);
      const queueIds = legado
        ? ids(p.queueIds).filter((id) => daConexao.has(id))
        : ids(p.queueIds);
      if (!exato && !antesDaFila && !(legado && queueIds.length > 0)) return null;
      return {
        id: p.id,
        name: p.name,
        antesDaFila,
        legado: legado && queueIds.length > 0,
        filas: (exato || legado ? queueIds : []).map(
          (id) => filaPorId.get(id) || { id, name: `#${id}` }
        ),
      };
    })
    .filter(Boolean)
    .sort((a, b) => String(a.name || "").localeCompare(String(b.name || "")));
};
